(() => {
  'use strict';
  document.querySelectorAll('[data-f2w-fightbase]').forEach((root) => {
    if (root.dataset.f2wInitialized === 'true') return;
    root.dataset.f2wInitialized = 'true';
    const holder = root.querySelector('[data-f2w-hub-summary]');
    const status = root.querySelector('[data-f2w-hub-status]');
    const error = root.querySelector('[data-f2w-hub-error]');
    try {
      const payload = JSON.parse(holder?.textContent || 'null');
      const hub = payload?.hub;
      if (!payload?.generatedAt || !hub) throw new Error('Missing verified Hub summary');
      const keys = ['sports', 'fighters', 'trainers', 'gyms', 'events', 'venues', 'iconic', 'organizations', 'archive'];
      if (!keys.every((key) => Number.isSafeInteger(hub[key]) && hub[key] >= 0)) throw new Error('Incomplete Hub summary');
      if (hub.iconic > hub.venues) throw new Error('Invalid venue summary');
      const counts = {
        sports: hub.sports,
        people: hub.fighters + hub.trainers,
        gyms: hub.gyms,
        events: hub.events,
        venues: hub.venues,
        organizations: hub.organizations,
        historical: hub.archive
      };
      const locale = document.documentElement.lang || 'nl-NL';
      Object.entries(counts).forEach(([key, value]) => {
        root.querySelectorAll(`[data-f2w-hub-count="${key}"]`).forEach((node) => {
          node.textContent = value.toLocaleString(locale);
        });
      });
      if (status) status.hidden = true;
      if (error) error.hidden = true;
    } catch (cause) {
      if (status) status.hidden = true;
      if (error) {
        error.hidden = false;
        error.textContent = root.dataset.labelError || '';
      }
      console.warn('[FightBase Hub] Summary unavailable', cause);
    }
  });
})();
